import { EventKind, EventFrequency, PensionType } from '../enums';
import { MoneyAmount } from '../value-objects/MoneyAmount';
import { AgeYears } from '../value-objects/AgeYears';

export interface ScenarioEventInit {
  id: string;
  kind: EventKind;
  label: string;
  amount: number;
  startAge: number;
  frequency?: EventFrequency;
  durationYears?: number;
  inflationAdjusted?: boolean;
  enabled?: boolean;
  note?: string;
  pensionType?: PensionType;
  growthRate?: number;
}

export class ScenarioEvent {
  readonly id: string;
  readonly kind: EventKind;
  readonly label: string;
  readonly amount: MoneyAmount;
  readonly startAge: AgeYears;
  readonly frequency: EventFrequency;
  readonly durationYears: number;
  readonly inflationAdjusted: boolean;
  readonly enabled: boolean;
  readonly note: string | undefined;
  readonly pensionType: PensionType | undefined;
  readonly growthRate: number | undefined;

  constructor(init: ScenarioEventInit) {
    this.id = init.id;
    this.kind = init.kind;
    this.label = init.label;
    this.amount = new MoneyAmount(init.amount);
    this.startAge = new AgeYears(init.startAge);
    this.frequency = init.frequency ?? EventFrequency.monthly;
    this.durationYears = init.durationYears ?? 0;
    this.inflationAdjusted = init.inflationAdjusted ?? true;
    this.enabled = init.enabled ?? true;
    this.note = init.note;
    this.pensionType = init.pensionType;
    this.growthRate = init.growthRate;
  }

  equals(other: ScenarioEvent): boolean {
    return this.id === other.id;
  }
}